<template>
  <div class="v-atlas-system-buttons">
    <div class="v-atlas-system-buttons__wrapper">
      <RouterLink v-if="!hideMainMenuButton" class="v-app-header-bar__home-button" :to="'/'"
        data-tooltip="Zur Startseite" />

      <!--
      <a v-if="isInIframe" class="v-app-header-bar__new-tab-button" :href="newTabUrl" target="metropolatlas"
        data-tooltip="Im Metropolatlas öffnen (neuer Tab)">a</a>
      -->

      <SmartButton v-if="!hideNotificationsButton" v-model="showMessageCenter" class="v-app-header-bar__messages-button"
        boolean :data-tooltip="messagesButtonTooltip">
        <div v-if="unreadMessages.length > 0" class="messages-notifier-bubble" v-html="unreadMessages.length" />
      </SmartButton>

      <SmartButton v-model="contextHelp.enabled" class="v-app-header-bar__context-help-button" boolean
        :data-tooltip="contextHelp.enabled ? 'Kontexthilfe deaktivieren' : 'Kontexthilfe aktivieren'">

      </SmartButton>


      <RouterLink class="v-app-header-bar__legal-button" data-tooltip="Impressum" :to="'/impressum/page/'">

      </RouterLink>
    </div>

    <Popup v-model:show="showMessageCenter" class="x-left x-w-400" title="Systemnachrichten"
      :allow-outside-interaction="true" :close-on-outside-click="true" @close="onMessagesPopupClose">
      <MessagesList />
    </Popup>
  </div>
</template>

<script setup lang="ts">

import { useRoute } from 'vue-router'
import { computed, ref } from 'vue';
import { useMessages } from '@/composables/useMessages';
import { Popup, SmartButton, contextHelp } from 'gertrud';
import MessagesList from './MessagesList.vue';

const showMessageCenter = ref(false)
const route = useRoute()


const { messages: notifications } = useMessages()

const hideMainMenuButton = computed(() => {
  return route.query.hideMainMenuButton
})


const hideNotificationsButton = computed(() => {
  return route.query.hideNotificationsButton
})

const newTabUrl = computed(() => {
  const url = new URL(window.location.href)

  /*
  // Strip params from real search string (pre-hash)
  url.searchParams.delete("hideMainMenuButton")
  url.searchParams.delete("hideNotificationsButton")

  // Also strip params encoded inside the hash fragment (hash-mode routing)
  const [hashPath, hashSearch] = url.hash.split('?')
  if (hashSearch) {
    const hashParams = new URLSearchParams(hashSearch)
    hashParams.delete("hideMainMenuButton")
    hashParams.delete("hideNotificationsButton")
    const remaining = hashParams.toString()
    url.hash = remaining ? `${hashPath}?${remaining}` : hashPath
  }
*/
  return url.toString()
})


const unreadMessages = computed(() => {
  return notifications.value.filter(n => n.read !== true)
})

const messagesButtonTooltip = computed(() => {

  let result = ""

  if (unreadMessages.value.length == 1) {
    result += `1 neue Systemnachricht.`
  } else if (unreadMessages.value.length > 1) {

    result += `${unreadMessages.value.length} neue Systemnachrichten.`
  } else {
    result += `Keine neuen Systemnachrichten.`
  }

  result += ` ${notifications.value.length} Systemnachrichten insgesamt.`

  return result
})


function onMessagesPopupClose() {
  for (const n of notifications.value) {
    n.read = true

  }

}

const isInIframe = computed(() => {
  try {
    return window.self !== window.top;
  } catch (e) {
    // Cross-origin access to window.top can throw
    return true;
  }
})
</script>
